module.exports = __webpack_public_path__ + "static/media/operations-feature-1.aee0c875.svg";